import React from 'react';
import clsx from 'clsx';
import pageStyles from '../WarrantyRequest.module.scss';
import { LottieContainer } from '../../../../components/animations/LottieContainer.tsx';
import animationData from '../../../../assets/animations/loader_big.json';
import {
  Button,
  ButtonColor,
} from '../../../../components/uikit/buttons/Button.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';

type OwnProps = {
  requestNumber: string;
  turnOffSubmitLoader: () => void;
};

const Email = 'TechnicalService@Löwensteinmedical.de';

export const SubmitLoading = (props: OwnProps) => {
  const { requestNumber, turnOffSubmitLoader } = props;

  const i18n = useScopedTranslation('Page.WarrantyPage');

  const navigate = useNavigate();

  const navigateHome = () => {
    void navigate('/');
  };

  return (
    <div
      className={clsx(pageStyles.errorContainer, pageStyles.columnContainer)}
    >
      <LottieContainer
        animationData={animationData}
        segments={!requestNumber ? [1, 180] : [180, 270]}
        loop={!requestNumber}
      />
      {!requestNumber ? (
        <div className={clsx(pageStyles.marginTop30)}>
          <div className={pageStyles.errorTitle}>
            {i18n.t('sending_submit_request')}
          </div>
        </div>
      ) : (
        <div
          className={clsx(
            pageStyles.columnContainer,
            pageStyles.marginTop30,
            pageStyles.alignItemsCenter,
          )}
        >
          <div
            className={clsx(pageStyles.errorTitle, pageStyles.marginBottom10)}
          >
            {i18n.t('request_success')}
          </div>
          <div className={pageStyles.text}>
            {i18n.t('contact_info', { requestNumber: `№${requestNumber}` })}
          </div>
          <NavLink
            className={clsx(pageStyles.link, pageStyles.underline)}
            to={`mailto:${Email}`}
          >
            {Email}
          </NavLink>
          <div
            className={clsx(pageStyles.rowContainer12, pageStyles.marginTop80)}
          >
            <Button
              testId={'create-another-request-button'}
              title={i18n.t('create_new_request')}
              color={ButtonColor.Secondary}
              onClick={turnOffSubmitLoader}
            />
            <Button title={i18n.t('go_home_page')} onClick={navigateHome} />
          </div>
        </div>
      )}
    </div>
  );
};
